import { useRef } from "react";
import React, { useEffect, useState, useCallback } from "react";
import { faCheck, faTimes, faInfoCircle, faBlackboard, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { Modal, Button } from 'react-bootstrap';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';


const MOBILE_REGEX = /^[0-9]{10}$/;
const AMOUNT_REGEX = /^[0-9]$/;
const ADD_GURUDAKSHINA_URL = "add-gurudakshina";

const ArthikSakhaAddGurudakshina = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
  };

  const { Id } = useParams();
  const axiosPrivate = useAxiosPrivate();
  const nameRef = useRef();
  const mobileRef = useRef();
  const amountRef = useRef();
  const chequeNoRef = useRef();

  const errRef = useRef();
  const sucssRef = useRef();

  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [amount, setAmount] = useState("");
  const [house_name, setHouse_name] = useState("");
  // const [originalDate, setOriginalDate] = useState("");
  const today = new Date().toISOString().split('T')[0]; // "YYYY-MM-DD"
  const [originalDate, setOriginalDate] = useState(today);
  const [pan, setPan] = useState("");
  const [pincode, setPincode] = useState("");
  const [postOffice, setPostOffice] = useState("");
  const [error, setError] = useState('');


  const [validMobile, setValidMobile] = useState(false);
  const [validName, setValidName] = useState(false);
  const [validAmount, setValidAmount] = useState(false);
  const [validChequeNo, setValidChequeNo] = useState(false);


  const [chequeNoFocus, setChequeNoFocus] = useState(false);
  const [amountFocus, setAmountFocus] = useState(false);
  const [mobileFocus, setMobileFocus] = useState(false);
  const [nameFocus, setNameFocus] = useState(false);
  const { auth } = useAuth();
  const [selectedSakha, setSelectedSakha] = useState('');

  const [selectedShreni, setSelectedShreni] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [chequeNo, setChequeNo] = useState("");
  const [bank, setBank] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [sakhaList, setSakhaList] = useState([]);
  const [shreniList, setShreniList] = useState([]);
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [bankList, setBankList] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const gurudakshinasPerPage = 15;
  const [gurudakshinas, setGurudakshinas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sthanId, setsthanId] = useState(Id); // default value
  const [sthanName, setSthanName] = useState(Id);

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");

  const navigate = useNavigate();
  // const [success, setSuccess] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);


  const [proudaSubmitted, setProudaSubmitted] = useState(false);
  const [vidyarthiSamyukthaSubmitted, setVidyarthiSamyukthaSubmitted] = useState(false);
  const [vidyarthiTharunaSubmitted, setVidyarthiTharunaSubmitted] = useState(false);
  const [vyavasayiTharunaSubmitted, setVyavasayiTharunaSubmitted] = useState(false);
  const [FinalSubmissionList, setFinalSubmissionList] = useState([]);
  const [Finilized, setFinilized] = useState([]);

  // const [selectedSakha, setSelectedSakha] = useState('');
  const [sakhaWarning, setSakhaWarning] = useState(false);

  const [year, month, day] = originalDate.split("-");
  const formattedDate = `${day}/${month}/${year}`;

  const fetchFinalSubmissionList = useCallback(async () => {
    setError(null);
    try {
      const response = await axiosPrivate.get(`list-final-submissions?sthan_id=${Id}`, {
        withCredentials: true,
      });

      const data = response.data;
      setFinalSubmissionList(data);
      setLoading(false);

      data.forEach(item => {
        switch (item.sakha) {
          case "Prouda":
            setProudaSubmitted(item.isSubmitted);

            break;
          case "Vidyarthi Samyuktha":
            setVidyarthiSamyukthaSubmitted(item.isSubmitted);
            break;
          case "Vidyarthi Tharuna":
            setVidyarthiTharunaSubmitted(item.isSubmitted);
            break;
          case "Vyavasayi Tharuna":
            setVyavasayiTharunaSubmitted(item.isSubmitted);
            break;
          default:
            break;
        }
      });

    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");
      setLoading(false);
    }
  }, [axiosPrivate, Id]);


  const fetchSthanName = useCallback(async () => {
    setError(null);
    try {
      const response = await axiosPrivate.get(`get-sthan?sthan_id=${Id}`, {
        withCredentials: true,
      });
      const data = response.data;
      setSthanName(data.sthan_name);
      setLoading(false);

    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");
      setLoading(false);
    }
  }, [axiosPrivate, Id]);

  useEffect(() => {
    fetchSthanName();
    fetchFinalSubmissionList();
  }, []);




  const handleSakhaChange = (e) => {
    const value = e.target.value;
    setSelectedSakha(value); // still async, but we use `value` below

    let finalizedValue = false;

    if (value === "Prouda") {
      finalizedValue = proudaSubmitted;
    } else if (value === "Vidyarthi Samyuktha") {
      finalizedValue = vidyarthiSamyukthaSubmitted;
    } else if (value === "Vidyarthi Tharuna") {
      finalizedValue = vidyarthiTharunaSubmitted;
    } else if (value === "Vyavasayi Tharuna") {
      finalizedValue = vyavasayiTharunaSubmitted;
    }

    setFinilized(finalizedValue); // still update your state
    setSakhaWarning(finalizedValue === true);
  };




  const fetchGurudakshina = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`/list-gurudakshina?sthan_id=${sthanId}&orderby=desc`, {
        withCredentials: true,
      });
      const franchiseList = response.data;
      setGurudakshinas(franchiseList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Gurudakshina:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No Vibhags available.");
      setLoading(false);
    }
  }, [axiosPrivate, sthanId]); // 👈 dependency added

  const handleViewClick = (franchiseId) => {
    // Navigate to the GetFranchise component with franchiseId as a URL parameter
    navigate(`/view/gurudakshina/${franchiseId}`);
  };
  useEffect(() => {
    fetchGurudakshina();
  }, [fetchGurudakshina]);

  const fetchSakhaList = async () => {
    try {
      // Uncomment this when using real API:
      const res = await axiosPrivate.get('get-sakhas');
      setSakhaList(res.data);

    } catch (err) {
      console.error("Failed to fetch sakhas", err);
      // fallback data on error
    }
  };

  const fetchShreniList = async () => {
    try {
      // Uncomment this when using real API:
      const res = await axiosPrivate.get('get-shrenies');
      setShreniList(res.data);

    } catch (err) {
      console.error("Failed to fetch Shreni", err);
      // fallback data on error
    }
  };


  const fetchPaymentMode = async () => {
    try {
      // Uncomment this when using real API:
      // const res = await axios.get('API_URL/list-PaymentMode');
      // setShreniList(res.data);

      // Mock data if API fails or during development:
      setPaymentModeList([
        "Cheque",
        "Cash",
      ]);
    } catch (err) {
      console.error("Failed to fetch Payment Modes", err);
      // fallback data on error
      setPaymentModeList([
        "Cheque",
        "Cash",
      ]);
    }
  };


  const fetchBankList = async () => {
    try {
      // Uncomment this when using real API:
      // const res = await axios.get('API_URL/list-PaymentMode');
      // setShreniList(res.data);

      // Mock data if API fails or during development:
      setBankList([
        "Allahabad Bank",
        "Andhra Bank",
        "Axis Bank",
        "Bank of Baroda",
        "Bank of India",
        "Bank of Maharashtra",
        "Canara Bank",
        "Corporation Bank",
        "CSB Bank(formerly known as Catholic Syrian Bank Ltd)",
        "Dhanlaxmi Bank(known as Dhanalakshmi Bank before name change in 2010)",
        "ESAF Small Finance Bank",
        "Federal Bank(In 1931 originally known as Travancore Federal Bank)",
        "Kerala Bank",
        "Kerala Gramin Bank",
        "ICICI Bank",
        "HDFC Bank",
        "Kotak Mahindra Bank",
        "Punjab National Bank",
        "South Indian Bank",
        "State Bank of India",
      ]);
    } catch (err) {
      console.error("Failed to fetch Bank List", err);
      // fallback data on error

    }
  };



  useEffect(() => {
    fetchPaymentMode();
  }, []);

  useEffect(() => {
    fetchSakhaList();
  }, []);
  useEffect(() => {
    fetchShreniList();
  }, []);


  useEffect(() => {
    nameRef.current?.focus();
  }, []);



  useEffect(() => {
    const isValid = /^(?!.*\d).{2,}$/.test(name);
    // (?!.*\d) → negative lookahead, ensures no digits 0–9
    // .{2,}    → any 2 or more characters (except newlines)
    setValidName(isValid);
  }, [name]);

  useEffect(() => {
    setValidMobile(MOBILE_REGEX.test(mobile));
  }, [mobile]);

  useEffect(() => {
    setValidAmount(AMOUNT_REGEX.test(amount));
  }, [amount]);



  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      var data = JSON.stringify({
        sthan_id: Id,
        name,
        sakha: selectedSakha,
        shreni: selectedShreni,
        amount,
        payment_mode: selectedPaymentMode,
        mobile: mobile,
        cheque_no: chequeNo,
        bank: selectedBank,
        house_name,
        date_of_samarppan: formattedDate,
        pan: pan,
        pincode: pincode,
        post_office: postOffice
      });

      const response = await axiosPrivate.post(ADD_GURUDAKSHINA_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      fetchGurudakshina();
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current.focus();
    }


  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // clear success message
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // clear error message
      setShowSuccessModal(true); // Show modal

      // Auto close after 10 seconds (10000 ms)
      setTimeout(() => {
        setShowSuccessModal(false);
      }, 5000);
    }
  };





  const indexOfLastGurudakshina = currentPage * gurudakshinasPerPage;
  const indexOfFirstGurudakshina = indexOfLastGurudakshina - gurudakshinasPerPage;
  const currentGurudakshina = gurudakshinas.slice(indexOfFirstGurudakshina, indexOfLastGurudakshina);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(gurudakshinas.length / gurudakshinasPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }



  return (
    <>
      <Container>
        <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
          <Modal.Header closeButton>
            {/* <Modal.Title>Success</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <p>{sucssMsg}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={() => setShowSuccessModal(false)}>
              OK
            </Button>
          </Modal.Footer>
        </Modal>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}


        <section className="empbody">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={sucssRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>



          <div className="wrapper wrapper2 newraps">
            <form>
              <h4 class="newraphead">Add Gurudhakshina in <span className="newspanz">{sthanName}</span> Sthan</h4>

              <Row>
                <Col md={6}>
                  <div className="input-box arthik_input-box">
                    <select
                      id="sakhaSelect"
                      className="form-control guruselect"
                      value={selectedSakha}
                      onChange={handleSakhaChange}
                    >
                      <option value="">-- Select Ultsavam --</option>
                      {sakhaList.map((sakha, index) => (
                        <option key={index} value={sakha}>
                          {sakha}
                        </option>
                      ))}
                    </select>

                    {sakhaWarning && (
                      <small className="text-danger mt-1">{selectedSakha} Finalized</small>
                    )}
                  </div>
                </Col>


                <Col md={6} >
                  <div className="input-box arthik_input-box">
                    <select
                      id="shreniSelect"
                      className="form-control guruselect"
                      value={selectedShreni}
                      onChange={(e) => setSelectedShreni(e.target.value)}
                    // disabled={Finilized}

                    >
                      <option value="">-- Select Shreni --</option>
                      {shreniList.map((shreni, index) => (
                        <option key={index} value={shreni}>{shreni}</option>
                      ))}
                    </select>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="input-box arthik_input-box">
                    <input
                      type="text"
                      id="name"
                      className="newinpstyle"
                      placeholder="Enter Name"
                      autoComplete="off"
                      ref={nameRef}
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                      required
                      aria-invalid={validName ? "false" : "true"}
                      aria-describedby="namenote"
                      onFocus={() => setNameFocus(true)}
                      onBlur={() => setNameFocus(false)}
                    // disabled={Finilized}
                    />
                    <p
                      id="namenote"
                      className={
                        nameFocus && name && !validName ? "instructions" : "offscreen"
                      }
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                      Name is required!
                    </p>
                  </div>
                </Col>




                <Col md={6}>
                  <div className="input-box arthik_input-box">
                    <input
                      // disabled={Finilized}
                      type="tel"
                      id="mobile"
                      className="telstyle newinpstyle"
                      placeholder="Enter Mobile number"
                      autoComplete="off"
                      ref={mobileRef}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ''); // remove non-digits
                        setMobile(value);
                      }}
                      value={mobile}
                      required
                      aria-invalid={validMobile ? "false" : "true"}
                      aria-describedby="namenote"
                      onFocus={() => setMobileFocus(true)}
                      onBlur={() => setMobileFocus(false)}

                    />

                    {/* <small
                      className={!mobile
                        ? "text-danger mt-1 d-block"
                        : "d-none"
                      }
                    >
                      Mobile number is required!.
                    </small> */}
                  </div>

                </Col>
                <Col md={6}>

                  <div className="input-box arthik_input-box">
                    <input
                      // disabled={Finilized}
                      type="text"
                      id="amount"
                      className="newinpstyle"
                      placeholder="Enter Amount"
                      autoComplete="off"
                      ref={amountRef}
                      onChange={(e) => {
                        let value = e.target.value;
                        // Allow only numbers and one dot
                        value = value.replace(/[^0-9.]/g, ''); // remove non-digits/non-dot
                        const parts = value.split('.');
                        if (parts.length > 2) {
                          // If more than one dot, remove extras
                          value = parts[0] + '.' + parts[1];
                        }
                        setAmount(value);
                      }}
                      value={amount}
                      required
                      aria-describedby="amountnote"
                      onFocus={() => setAmountFocus(true)}
                      onBlur={() => setAmountFocus(false)}
                    />

                    <small
                      className={!amount
                        ? "text-danger mt-1 d-block"
                        : "d-none"
                      }
                    >
                      Amount is required!.
                    </small>
                  </div>
                </Col>

                {parseFloat(amount) > 1999 && (
                  <Col md={6}>
                    <div className="input-box arthik_input-box">
                      <input
                        // disabled={Finilized}
                        type="text"
                        id="pan"
                        className="newinpstyle"
                        placeholder="Enter PAN"
                        autoComplete="off"
                        onChange={(e) => setPan(e.target.value)}
                        value={pan}
                      />
                    </div>
                  </Col>
                )}

                <Col md={6}>
                  <div className="input-box arthik_input-box">
                    <select
                      // disabled={Finilized}
                      id="shrenSelect"
                      className="form-control guruselect"
                      value={selectedPaymentMode}
                      onChange={(e) => setSelectedPaymentMode(e.target.value)}
                    >
                      <option value="">-- Select Payment Mode --</option>
                      {paymentModeList.map((paymentMode, index) => (
                        <option key={index} value={paymentMode}>
                          {paymentMode}
                        </option>
                      ))}
                    </select>

                    {error && <p style={{ color: 'red' }}>{error}</p>}
                  </div>
                </Col>

                {selectedPaymentMode === "Cheque" && (
                  <>
                    <Col md={6}>
                      <div className="input-box arthik_input-box">

                        <input
                          // disabled={Finilized}
                          type="text"
                          id="bankSelect"
                          className="newinpstyle"
                          placeholder="Enter Bank name"
                          autoComplete="off"
                          onChange={(e) => setSelectedBank(e.target.value)}
                          value={selectedBank}

                          required
                          aria-describedby="namenote"
                          onFocus={() => setChequeNoFocus(true)}
                          onBlur={() => setChequeNoFocus(false)}
                        />
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="input-box arthik_input-box">
                        <input
                          // disabled={Finilized}
                          type="text"
                          id="cheque_no"
                          className="newinpstyle"
                          placeholder="Enter Cheque no"
                          autoComplete="off"
                          ref={chequeNoRef}
                          onChange={(e) => setChequeNo(e.target.value)}
                          value={chequeNo}
                          required
                          aria-invalid={validChequeNo ? "false" : "true"}
                          aria-describedby="namenote"
                          onFocus={() => setChequeNoFocus(true)}
                          onBlur={() => setChequeNoFocus(false)}
                        />
                      </div>
                    </Col>
                  </>
                )}


                <Col md={6}>
                  <div className="input-box arthik_input-box">
                    <input
                      // disabled={Finilized}
                      type="text"
                      id="house_name"
                      className="newinpstyle"
                      placeholder="Enter House name"
                      autoComplete="off"
                      onChange={(e) => setHouse_name(e.target.value)}
                      value={house_name}
                      required
                    />
                  </div>
                </Col>

                {house_name.trim() !== "" && (
                  <Col md={6}>
                    <div className="input-box arthik_input-box">
                      <input
                        // disabled={Finilized}
                        type="text"
                        id="pincode"
                        className="newinpstyle"
                        placeholder="Enter Pincode"
                        autoComplete="off"
                        onChange={(e) => {
                          const value = e.target.value;
                          // Only allow digits and up to 6 characters
                          if (/^\d{0,6}$/.test(value)) {
                            setPincode(value);
                          }
                        }}
                        value={pincode}
                        inputMode="numeric"
                        maxLength={6}
                      />
                    </div>
                  </Col>
                )}
                {house_name.trim() !== "" && (
                  <Col md={6}>
                    <div className="input-box arthik_input-box">
                      <input
                        disabled={Finilized}
                        type="text"
                        id="post_office"
                        className="newinpstyle"
                        placeholder="Enter Post office"
                        autoComplete="off"
                        onChange={(e) => {
                          const value = e.target.value;
                          setPostOffice(value);
                        }}
                        value={postOffice}
                      />
                    </div>
                  </Col>
                )}
                <Col md={6}>
                  <div className="input-box arthik_input-box">
                    <input
                      // disabled={Finilized}
                      type="date"
                      id="date"
                      className="newinpstyle"
                      onChange={(e) => setOriginalDate(e.target.value)}
                      value={originalDate}
                      required
                    />
                  </div>
                </Col>



                <Col md={12}>
                  <button
                    type="button" // Important to prevent form submit
                    className="btn"
                    onClick={handleSubmit} // Call this for "Sign Up"
                    disabled={
                      !validName
                      || !selectedSakha
                      || !selectedShreni
                      || !selectedPaymentMode
                      || !originalDate
                      || !house_name
                      // || Finilized
                    }
                  >
                    Add Gurudakshina
                  </button>
                </Col>
              </Row>
            </form>

          </div>

          <br></br>
          <div className="wrapperemp2">
            {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
            <h4 className="newshead newraphead">List Gurudakshina In <span className="newspanz">{sthanName}</span> Sthan</h4>

            <div className="table-container">
              <table id="customers">
                <thead>
                  <tr>
                    <th>Ultsavam</th>
                    <th>Shreni</th>
                    <th>Name</th>
                    <th>PAN</th>
                    <th>Mobile</th>
                    <th>Amount</th>
                    <th>Samarppan date</th>

                    <th>Options</th>
                  </tr>
                </thead>

                <tbody>
                  {error ? (
                    <tr>
                      <td colSpan="6" className="text-danger text-center">
                        {error}
                      </td>
                    </tr>
                  ) : gurudakshinas.length === 0 ? (
                    <tr>
                      <td colSpan="6">No Data available.</td>
                    </tr>
                  ) : (
                    currentGurudakshina.map(gurudakshina => (
                      <tr key={gurudakshina.id}>
                        <td>{gurudakshina.sakha}</td>
                        <td>{gurudakshina.shreni}</td>
                        <td>{gurudakshina.name}</td>
                        <td>{gurudakshina.pan}</td>
                        <td>{gurudakshina.mobile}</td>
                        <td>{gurudakshina.amount}</td>
                        <td>
                          {new Date(gurudakshina.date_of_samarppan).toLocaleString('en-IN', {
                            timeZone: 'Asia/Kolkata',
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                          }).replace(/ /g, '/')}
                        </td>


                        <td>
                          <button type="button" className="btn btn-info btn-ico" onClick={() => handleViewClick(gurudakshina.id)}>
                            <i className="bx bxs-show icon"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>


              </table>
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </section>
        {/* )} */}
      </Container>
    </>
  );
};

export default ArthikSakhaAddGurudakshina;
